module.exports = __webpack_public_path__ + "img/m_5.98257cab.png";